import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, options, token, isPublic) => appendPaginationQueryParamsToUrl(`${host}/${isPublic ? "public/" : ""}batchUpload/${token}?include=video;audio;image;binary`, { ...options,
  alreadyHasQueryParams: true
})

export default (host, isPublic = false) => (options, token) =>
  get(url(host, options, token, isPublic))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)